import React = require('react');
import RaisedButton from "material-ui/RaisedButton";
import CircularProgress from "material-ui/CircularProgress";
import diyLightTheme = require('diy/material-ui/diyLightTheme');

interface StateButtonState {
    loading: boolean;
}

interface StateButtonProps extends React.Props<StateButton> {
    label: string;
    onClick: Function;
    className?: string;
}

export default class StateButton extends React.Component<StateButtonProps, StateButtonState> {

    static childContextTypes: React.ValidationMap<any> = {
        muiTheme: React.PropTypes.object
    };

    private timeout: number;

    constructor(props: any) {
        super(props);

        this.state = {
            loading: false
        };
    }

    getChildContext() {
        return {
            muiTheme: diyLightTheme
        };
    }

    componentWillUnmount() {
        clearTimeout(this.timeout);
    }

    render() {
        let progressStyle = {
            display: "inline-block",
            verticalAlign: "middle",
            width: "36px",
            height: "36px"
        };
        let progressInnerStyle = {
            marginTop: "-7px"
        };
        let props = this.filterProps(this.props);

        if (this.state.loading === true) {
            return (
                <RaisedButton {...props} label={this.props.label} primary={true} labelPosition="after"
                              disabled={true} className={this.props.className}>
                    <CircularProgress size={0.3} color={diyLightTheme.raisedButton.primaryTextColor}
                                      style={progressStyle} innerStyle={progressInnerStyle} />
                </RaisedButton>
            );
        } else {
            return (
                <RaisedButton {...props} label={this.props.label} primary={true}
                              onTouchTap={this.handleClick} className={this.props.className} />
            );
        }
    }

    /**
     * Retrieves standard props to add it to our element without conflicts
     * (actually only the data-* props, can be extended)
     */
    private filterProps = (props: any): { [dataPropName: string]: string; } => {
        let filteredProps: any = {};

        for (let key in props) {
            if (props.hasOwnProperty(key) && key.match(/data\-.*/)) {
              filteredProps[key] = props[key];
            }
        }
        return filteredProps;
    };

    /**
     * Shows a loading animation before running the onclick action
     *
     * The timeout is for UX effect. It's a small waiting time to see
     * a bit of the loading animation before the button action happens,
     * otherwise the "waiting state" is not clear for the user.
     */
    private handleClick = () => {
        this.setState({
            loading: true
        }, () => {
            this.timeout = setTimeout(() => {
                this.props.onClick();
            }, 400);
        });
    };
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/externalwebsiteimport/stateButton/StateButton.tsx
 **/